import { render, staticRenderFns } from "./ComprasDiretasAbertasTituloSecao.vue?vue&type=template&id=355a267a&scoped=true"
import script from "./ComprasDiretasAbertasTituloSecao.vue?vue&type=script&lang=js"
export * from "./ComprasDiretasAbertasTituloSecao.vue?vue&type=script&lang=js"
import style0 from "./ComprasDiretasAbertasTituloSecao.vue?vue&type=style&index=0&id=355a267a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a267a",
  null
  
)

export default component.exports